import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import animated from "animate.css";
import "./assets/css/index.css";
import "./assets/css/markdown.css";
import './assets/icons' // icon
import config from "./assets/js/config";
import Share from "vue-social-share";
import "vue-social-share/dist/client.css";
import { vueBaberrage } from "vue-baberrage";
import axios from "axios";
import VueAxios from "vue-axios";
import InfiniteLoading from "vue-infinite-loading";
import "highlight.js/styles/atom-one-dark.css";
import VueImageSwipe from "vue-image-swipe";
import "vue-image-swipe/dist/vue-image-swipe.css";
import Toast from "./components/toast";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import VueCookie from "vue-cookie";

import { parseTime,selectDictLabel} from '@/utils/ruoyi'


Vue.use(VueCookie); // 挂在在全局了
Vue.prototype.config = config;
Vue.prototype.parseTime = parseTime
Vue.prototype.selectDictLabel = selectDictLabel
Vue.config.productionTip = false;
Vue.use(animated);
Vue.use(Share);
Vue.use(vueBaberrage);
Vue.use(InfiniteLoading);
Vue.use(VueAxios, axios);
Vue.use(VueImageSwipe);
Vue.use(Toast);

Vue.filter("date", function(value) {
  return parseTime(value,"{y}-{m}-{d}");
});

Vue.filter("dateTime", function(value) {
  return parseTime(value,"{y}-{m}-{d} {h}:{i}:{s}");
});

Vue.filter("time", function(value) {
  return parseTime(value,"{h}:{i}:{s}");
});

Vue.filter("num", function(value) {
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + "k";
  }
  return value;
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: "instant"
  });
  NProgress.done();
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
